// src/services/api.js
import axios from 'axios';
import notasPagamentoData from '../data/notasPagamento.json';
import solicitacoesData from '../data/solicitacoes.json';
import insumosData from '../data/insumos.json';
import notasServicoData from '../data/notasServico.json';

const API_BASE_URL = 'https://app.rental.itup.com.br';

const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 45000,
});

// ——— injeta token-fornecedor em TODAS as requisições
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token-fornecedor');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// ——— captura 401/403 e manda de volta pro login
api.interceptors.response.use(
    (res) => res,
    (err) => {
        const status = err.response?.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token-fornecedor');
            window.location.href = '/login';
        }
        return Promise.reject(err);
    },
);

// ——— função de login igual ao portal_locador, só que com app_id=4
export function login({aliasAccess, username, password}) {
    return api.post('/rental_auth/api/customer-auth/login', {
        aliasAccess,
        username,
        password,
        app_id: 4,
    });
}

// ——— wrapper para as chamadas do EasyHub
export const easyHubRequest = (metodo, url = 1, params = {}, data = {}, method = 'get') => {
    return api.request({
        url: '/rental_auth/api/easyhub/default',
        method,
        params: {metodo, url, ...params},
        data,
    });
};
// Dados placeholder existentes
export function fetchNotasPagamento() {
    return Promise.resolve({data: notasPagamentoData});
}

export function fetchSolicitacoes() {
    return Promise.resolve({data: solicitacoesData});
}

// Novos métodos
export function fetchInsumos() {
    return Promise.resolve({data: insumosData});
}

export function fetchNotasServico() {
    return Promise.resolve({data: notasServicoData});
}

export default api;
